var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticStyle: {
            display: "flex",
            "flex-wrap": "wrap",
            "justify-content": "space-between",
          },
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "150px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "字段名称", prop: "itemName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "字段名称", disabled: "" },
                model: {
                  value: _vm.dataForm.displayName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "displayName", $$v)
                  },
                  expression: "dataForm.displayName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "字段编码", prop: "itemCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "字段编码" },
                model: {
                  value: _vm.dataForm.itemCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "itemCode", $$v)
                  },
                  expression: "dataForm.itemCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "字段名称[数据库]", prop: "columnName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "字段名称[数据库]", disabled: "" },
                model: {
                  value: _vm.dataForm.columnName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "columnName", $$v)
                  },
                  expression: "dataForm.columnName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否为查重字段", prop: "isUnionIndex" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "是否为查重字段" },
                  model: {
                    value: _vm.dataForm.isUnionIndex,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "isUnionIndex", $$v)
                    },
                    expression: "dataForm.isUnionIndex",
                  },
                },
                _vm._l(_vm.trueOrFalseOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否必填", prop: "required" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "是否隐藏", disabled: "" },
                  model: {
                    value: _vm.dataForm.required,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "required", $$v)
                    },
                    expression: "dataForm.required",
                  },
                },
                _vm._l(_vm.trueOrFalseOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "默认值", prop: "defaultValue" } },
            [
              _c("el-input", {
                attrs: { placeholder: "默认值" },
                model: {
                  value: _vm.dataForm.defaultValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "defaultValue", $$v)
                  },
                  expression: "dataForm.defaultValue",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "验证规则类型", prop: "validType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "验证规则类型" },
                  model: {
                    value: _vm.dataForm.validType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "validType", $$v)
                    },
                    expression: "dataForm.validType",
                  },
                },
                _vm._l(_vm.validTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.value, value: item.key },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据类型", prop: "dataType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "数据类型" },
                  model: {
                    value: _vm.dataForm.dataType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "dataType", $$v)
                    },
                    expression: "dataForm.dataType",
                  },
                },
                _vm._l(_vm.dataTypeList, function (key, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: key.value, value: key.key },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.dataForm.validType == 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "匹配字符串长度类型",
                    prop: "jsonContentType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        display: "block",
                        "margin-bottom": "10px",
                      },
                      attrs: { clearable: "", placeholder: "类型选择" },
                      on: {
                        change: _vm.handleChooseTool,
                        clear: function ($event) {
                          return _vm.clearSelect("jsonContentType")
                        },
                      },
                      model: {
                        value: _vm.dataForm.jsonContentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "jsonContentType", $$v)
                        },
                        expression: "dataForm.jsonContentType",
                      },
                    },
                    _vm._l(_vm.jsonContentTypeList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.value, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.validType == 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "匹配字符串长度",
                    prop: "jsonContent",
                    error: _vm.jsonContentError,
                  },
                },
                [
                  _c("el-input-number", {
                    staticClass: "elInputNumber",
                    style: {
                      width:
                        _vm.dataForm.jsonContentType == 4
                          ? "calc(50% - 8px)"
                          : "100%",
                    },
                    attrs: {
                      controls: false,
                      min: 1,
                      placeholder: "请输入数字",
                    },
                    model: {
                      value: _vm.dataForm.jsonContent,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "jsonContent", $$v)
                      },
                      expression: "dataForm.jsonContent",
                    },
                  }),
                  _vm.dataForm.jsonContentType == 4
                    ? _c("span", [_vm._v(" - ")])
                    : _vm._e(),
                  _vm.dataForm.jsonContentType == 4
                    ? _c("el-input-number", {
                        staticClass: "elInputNumber",
                        staticStyle: { width: "calc(50% - 8px)" },
                        attrs: {
                          controls: false,
                          min: 1,
                          placeholder: "请输入数字",
                        },
                        model: {
                          value: _vm.dataForm.jsonContentMax,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "jsonContentMax", $$v)
                          },
                          expression: "dataForm.jsonContentMax",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.dataForm.validType == 99
            ? _c(
                "el-form-item",
                { attrs: { label: "匹配表达式", prop: "patternRegex" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "匹配表达式" },
                    model: {
                      value: _vm.dataForm.patternRegex,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "patternRegex", $$v)
                      },
                      expression: "dataForm.patternRegex",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "sort", $$v)
                  },
                  expression: "dataForm.sort",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "依赖项校验", prop: "linkTable" } },
            [
              _c("el-input", {
                attrs: { placeholder: "依赖项校验" },
                model: {
                  value: _vm.dataForm.linkTable,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "linkTable", $$v)
                  },
                  expression: "dataForm.linkTable",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }